import React, { memo } from 'react';
import { Text, useTheme } from '@Sage/hoi-poi-ui';

import designLottie from './addons_green-on-solid-black_animated.json';
import DesignOption from './DesignOption';
import htmlLottie from './link_green-on-solid-black_animated.json';
import templatesLottie from './heart_green-on-solid-black_animated.json';

import './styles.scss';

const DESIGN_OPTIONS = [
    {
        title: 'Create New',
        description: 'Design a new email from scratch or use built-in designs.',
        animation: designLottie,
    },
    {
        title: 'Your Templates',
        description: 'Edit a previously saved template design',
        animation: templatesLottie,
    },
    {
        title: 'HTML Editor',
        description: 'Paste the HTML of an email created in another tool',
        animation: htmlLottie,
    },
];

const DesignForm = memo(() => {
    const theme = useTheme();

    return (
        <div className="marketing-campaigns__design-form">
            <div className="marketing-campaigns__design-form-options">
                {DESIGN_OPTIONS.map(({ title, description, animation }) => (
                    <DesignOption
                        key={title}
                        title={title}
                        description={description}
                        animation={animation}
                        textColor={theme.colors.textLight.secondary}
                    />
                ))}
            </div>
        </div>
    );
});

DesignForm.displayName = 'DesignForm';

export default DesignForm;
